export const lightPurple = "#FDF3FF";
export const medPurple = "#973DA0";
export const darkPurple = "#400A41";
